import React from 'react'
import { Box, Grid, Modal } from '@mui/material'
import EQTextField from '../core/EQTextField'
import EQServiceCaregiver from '../../services/EQServiceCaregiver'
import EQCalendarStates from '../../libs/EQCalendarStates'
import Utils from '../../libs/Utils'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '80%',
  bgcolor: 'background.paper',
  border: '0',
  boxShadow: 24,
  p: 2,
  alignContent: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}

export default class EQEndModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  closeModal() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  cancelOperation() {
    this.closeModal()
  }

  actuallyDoOperation() {
    EQServiceCaregiver.dichiaraFine(this.props.selectedEvent).then((x) => {
      EQServiceCaregiver.getAppuntamento(
        this.props.selectedEvent.idCalendario
      ).then((x) => {
        Utils.refill(this.props.selectedEvent, x.data)
        this.closeModal()
      })
    })
  }

  render() {
    return (
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={style}
          className="helpModal">
          <Box
            mt={0}
            p={0}
            pt={2}
            pb={2}>
            <div className="textCenter playFair app-text modal-title">
              <b>Fine assistenza</b>
            </div>
            <div className="textCenter playFair app-text">
              Conferma qui per terminare la tua assistenza
            </div>

            <Grid
              container
              mt={0}
              mb={4}>
              <Grid
                item
                sx={{ textAlign: 'left' }}
                xs={6}>
                <a
                  className="buttonLink lnkForward"
                  onClick={() => this.cancelOperation()}>
                  ANNULLA
                </a>
              </Grid>
              <Grid
                item
                sx={{ textAlign: 'right' }}
                xs={6}>
                <a
                  className="buttonLink lnkForward"
                  onClick={() => this.actuallyDoOperation()}>
                  TERMINA
                </a>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    )
  }
}
